import { EnumOption } from './enum-option';

export const RecurrenceType = {
  Daily: 0,
  Weekly: 1,  
}

export const RecurrenceTypeList: EnumOption[] = [
  { value: RecurrenceType.Daily, label: 'Daily' },
  { value: RecurrenceType.Weekly, label: 'Weekly' },  
];